<script setup lang="ts">
import { useMonitoringStore } from '@/stores/monitoring.store'
import { computed } from 'vue'

const store = useMonitoringStore()
const message = computed(() => store.userMessage)

const bannerClass = computed(() => {
  // caster/player 양쪽 Link 상태를 종합하여 배너 스타일 결정
  const casterStatus = store.casterLinkState.status
  const playerStatus = store.playerLinkState.status
  if (casterStatus === 'disconnected' || playerStatus === 'disconnected') return 'banner-error'
  if (casterStatus === 'unstable' || playerStatus === 'unstable') return 'banner-warning'
  return 'banner-info'
})

function dismiss() {
  store.setUserMessage(null)
}
</script>

<template>
  <div v-if="message" class="user-message-banner" :class="bannerClass">
    <span class="message">{{ message }}</span>
    <button class="dismiss" @click="dismiss">&times;</button>
  </div>
</template>

<style scoped>
.user-message-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  font-size: 14px;
  gap: 12px;
}

.banner-error {
  background: #f8d7da;
  color: #721c24;
  border-bottom: 1px solid #f5c6cb;
}

.banner-warning {
  background: #fff3cd;
  color: #856404;
  border-bottom: 1px solid #ffeeba;
}

.banner-info {
  background: #d1ecf1;
  color: #0c5460;
  border-bottom: 1px solid #bee5eb;
}

.message {
  flex: 1;
  text-align: center;
}

.dismiss {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
}

.dismiss:hover {
  opacity: 1;
}
</style>
